/**
 * CloudWatch API endpoints used by logging services
 */
export const CLOUDWATCH_ENDPOINTS = {
  /** Single log write endpoint */
  SINGLE_LOG: '/cloudwatch/write-to-log-stream'
} as const;

/**
 * Log group names by environment
 */
export const LOG_GROUP_NAMES = {
  PRODUCTION: 'ground-control-prod',
  TEST: 'ground-control-test',
  DEVELOPMENT: 'ground-control-dev'
} as const;